import { combineReducers } from "redux";
import main from "./main.reducer";

export default combineReducers({
  main,
});
